/**
 * @description all the API calls to Innowave API
 */

const BASE_URL = process.env.INNOWAVE_API_URL;
console.debug('Innowave API URL', BASE_URL)

class InnowaveAPI {
    /**
     *
     * @param url
     * @param params
     * @returns {Promise<Response|void>}
     */
    #call = (url, params = null) => {
        return fetch(`${BASE_URL}${url}`, {
            method: 'POST',
            cache: 'no-cache',
            body: params
        })
            .then(response => response.json());
    }

    /**
     *
     * @param file
     * @returns {Promise<void>}
     */
    uploadFile = file => {
        const data = new FormData();
        data.append('file', file);
        return this.#call('UploadFile', data);
    }

    /**
     *
     * @param batchId
     * @returns {Promise<Response|void>}
     */
    getPercentProcessingBatch = batchId => {
        return this.#call(`GetPercentProcessingBatch?batchId=${batchId}`);
    }

    /**
     *
     * @param batchId
     * @returns {Promise<Response|void>}
     */
    getFoundDefinitions = batchId => {
        return this.#call(`GetFoundDefinitions?batchId=${batchId}`);
    }
}

// create instance and export it
const api = new InnowaveAPI();
export default api;